module.exports = __webpack_public_path__ + "static/media/bishop-vasily.bc3e34e5.jpg";